import { useCallback } from 'react'
import { useUpdateBasicInfoMutation } from 'src/apollo/onlineOrdering'
import { useOOClient } from 'src/shared/components/common/oo_client_provider/OOClientProvider'
import {
  showUpdateSuccess,
  showUpdateError
} from '../utils/accountNotifications'

export const useGuestAccountUpdate = (currentContact: any) => {
  const ooClient = useOOClient()
  const [updateBasicInfo] = useUpdateBasicInfoMutation()

  const updateBasicInformation = useCallback(
    async (formData: {
      firstName: string
      lastName: string
      phone: string
    }) => {
      // Only update if values changed
      if (
        currentContact?.firstName === formData.firstName &&
        currentContact?.lastName === formData.lastName
      ) {
        return { success: true }
      }

      try {
        const { data } = await updateBasicInfo({
          variables: {
            input: {
              firstName: formData.firstName,
              lastName: formData.lastName,
              phone: formData.phone
            }
          },
          client: ooClient
        })

        if (data?.updateBasicInfo.__typename === 'UpdateBasicInfoResponse') {
          showUpdateSuccess()
          return { success: true }
        } else {
          showUpdateError()
          return { success: false }
        }
      } catch (err) {
        showUpdateError()
        return { success: false, error: err }
      }
    },
    [updateBasicInfo, ooClient, currentContact]
  )

  return { updateBasicInformation }
}
